import FilterListIcon from '@mui/icons-material/FilterList';
import { Button, Menu, MenuItem, Typography } from '@mui/material';
import { useState } from 'react';
import { AbsColor, MouLookup } from '../../constants';
import { MOURiskAction } from '../../features/mou-risk.feature';
import { useAppDispatch, useAppSelector } from '../../hooks';

interface PscMouHeaderProps {
    postChange?: () => void;
}

const PscMouHeader = ({ postChange }: PscMouHeaderProps) => {
    const dispatch = useAppDispatch();

    const vessels = useAppSelector((state) => state.Vessel.List.Vessels);

    const [controlMenuFunction, setControlMenuFuction] = useState<null | HTMLElement>(null);
    const open = Boolean(controlMenuFunction);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setControlMenuFuction(event.currentTarget);
    };

    const handleClickMOU = (mouName: string) => {
        vessels?.forEach((vessel) => {
            dispatch(MOURiskAction.SelectByVesselMOU({ IMONumber: vessel.ImoNumber, MOU: mouName }));
        });

        setControlMenuFuction(null);
        if (postChange) postChange();
    };

    const handleCloseMenu = () => {
        setControlMenuFuction(null);
    };

    return (
        <>
            <Typography variant="h5" color={AbsColor.White1}>
                <Button onClick={handleClick} style={{ color: AbsColor.White1 }} variant="text">
                    MOU <FilterListIcon style={{ color: AbsColor.Gray2 }} sx={{ fontSize: 18, marginLeft: 1 }} />
                </Button>
            </Typography>
            <Menu anchorEl={controlMenuFunction} open={open} onClose={handleCloseMenu}>
                {Object.entries(MouLookup).map((value) => (
                    <MenuItem onClick={() => handleClickMOU(value[1])}>{value[1]}</MenuItem>
                ))}
            </Menu>
        </>
    );
};

export default PscMouHeader;
